import { useTranslation } from 'react-i18next';

import { DataPanelInlineItem } from '@/ui';
import { openEditIncidentLabelDialog } from '../../actions';

export type IncidentLabelPanelItemProps = {
  incidentId: string;
  incidentIsReadOnly: boolean;
  incidentLabel: string | null;
};

export function IncidentLabelPanelItem({ incidentId, incidentIsReadOnly, incidentLabel }: IncidentLabelPanelItemProps) {
  const { t } = useTranslation();

  return (
    <DataPanelInlineItem
      title={t('Incident_InfoPanel_IncidentLabel')}
      value={incidentLabel ?? undefined}
      editable={!incidentIsReadOnly}
      showEmptyPlaceholder
      onEditClick={() => openEditIncidentLabelDialog(incidentId, incidentLabel)}
    />
  );
}
